import styled from "styled-components"
import { heroHeader } from "./heroHeader.css";

export const HeroHeaderStyled = styled.div`
  ${heroHeader}
`